export enum ClaimStatePropertyType {
  PaymentState = 'paymentState',
  FooterButtonState = 'footerButtonState',
  ClaimEditState = 'claimEditState',
}
